import React, { createContext, useState, useMemo, useCallback } from 'react';

import AddCompanyNoteModal from '../modals/AddCompanyNoteModal';

export const CompanyContext = createContext({
  showAddCompanyNoteModal: () => {},
});

export default function CompanyContextProvider({ children }) {
  const [isAddCompanyNoteModalVisible, setIsAddCompanyNoteModalVisible] =
    useState(false);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [refetchCompany, setRefetchCompany] = useState(null);

  const showAddCompanyNoteModal = useCallback((company, refetch) => {
    setCurrentCompany(company);
    setIsAddCompanyNoteModalVisible(true);
    setRefetchCompany(() => refetch);
  }, []);

  const value = useMemo(
    () => ({
      showAddCompanyNoteModal,
    }),
    [showAddCompanyNoteModal]
  );

  return (
    <CompanyContext.Provider value={value}>
      {children}
      <AddCompanyNoteModal
        show={isAddCompanyNoteModalVisible}
        handleClose={() => {
          setIsAddCompanyNoteModalVisible(false);
          setCurrentCompany(null);
        }}
        currentCompany={currentCompany}
        refetch={refetchCompany}
      />
    </CompanyContext.Provider>
  );
}
